import React, { useState, useEffect } from "react";
import { FaInstagram, FaLinkedinIn, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/VibeWebLogo.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrolled, setScrolled] = useState(false); //  NEW

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      // Hide / Show navbar
      if (window.scrollY > lastScrollY) {
        setVisible(false);
      } else {
        setVisible(true);
      }

      setLastScrollY(window.scrollY);

      //  Change navbar style on scroll
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <>
      {/* NAVBAR */}
      <nav
  className={`fixed top-0 left-0 w-full z-50 transition-transform duration-700 ease-in-out ${
    visible ? "translate-y-0" : "-translate-y-full"
  } 
  bg-gradient-to-r from-white/50 via-blue-900/90 to-slate-950/90 
  backdrop-blur-xl border-b border-white/10 shadow-xl`}
>
        <div className="flex items-center justify-between px-8 py-4">

          {/* Logo */}
          <a href="#home" className="flex items-center">
            <img
              src={logo}
              alt="Logo"
              className="h-10 object-contain drop-shadow-md" // border removed
            />
          </a>

          {/* Right Side */}
          <div className="flex items-center gap-6">

            {/* Social Icons */}
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-yellow-300 transition"
            >
              <FaInstagram size={20} />
            </a>

            <a
              href="https://www.linkedin.com/company/vibewebmedia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-yellow-300 transition"
            >
              <FaLinkedinIn size={20} />
            </a>

            {/* Hamburger */}
            <button
            onClick={toggleMenu}
  className="relative text-white hover:text-yellow-300 transition"
>
  {/* Glow Pulse Ring */}
  <span className="absolute inset-0 rounded-full animate-ping bg-yellow-400 opacity-50"></span>
  {/* Main Button */}
  <span className="relative z-10 flex items-center justify-center">
    <FaBars size={22} />
  </span>
</button>
          </div>
        </div>
      </nav>

      {/* SIDEBAR */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-[#0d0d0d] shadow-lg transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out z-50`}
      >
        <div className="flex justify-between items-center px-6 py-5 border-b border-yellow-500/20">
          <h2 className="text-yellow-400 font-semibold text-lg">Menu</h2>
          <button
            onClick={toggleMenu}
            className="text-yellow-400 hover:text-yellow-300"
          >
            <FaTimes size={20} />
          </button>
        </div>

        <ul className="flex flex-col gap-6 px-8 py-8 text-white font-medium">
          <li>
            <a href="#home" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Home
            </a>
          </li>

          <li>
            <a href="#about" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              About Us
            </a>
          </li>

          <li>
            <a href="#services" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Services
            </a>
          </li>

          <li>
            <a href="#work" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Our Work
            </a>
          </li>

          <li>
            <a href="#about2" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Why Choose Us
            </a>
          </li>

          <li>
            <a href="#brands" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Brands
            </a>
          </li>

          <li>
            <a href="#connect" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Connect With Us
            </a>
          </li>
          
          <li>
            <a href="#verticals" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Verticals
            </a>
          </li>

          <li>
            <a href="#inquiry" onClick={toggleMenu} className="hover:text-yellow-400 transition">
              Inquiry
            </a>
          </li>
          <br></br><br></br><li className="hover:text-orange-400 transition"><a href="mailto:info@vibewebmedia.com">info@vibewebmedia.com</a></li>

        </ul>
      </div>

      {/* BACKDROP OVERLAY */}
      {isOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black/60 z-40"
        />
      )}
    </>
  );
}